import { supabase } from './supabase';

/**
 * "Heeft deze klant echt een kortingsmail gehad?" — leeslaag op
 * `GET /api/customers/marketing-summary`.
 */

export type MarketingVerdict =
  | 'geen-marketingcontact'
  | 'geen-marketingmail'
  | 'marketingmail-zonder-kortingsaanbod'
  | 'kortingsaanbod-verstuurd';

export interface DiscountOfferSend {
  sendId: string;
  templateKey: string;
  label: string;
  code: string | null;
  percentage: number;
  scope: 'reiniging' | 'ondertapijt';
  sentAt: string | null;
  subject: string | null;
  via: string | null;
}

export interface MarketingSummary {
  accountId: string | null;
  contacts: Array<{ id: string; email: string | null; sfAccountId: string | null; matchedOn: string }>;
  totalSends: number;
  sentCount: number;
  lastSendAt: string | null;
  discountOffers: DiscountOfferSend[];
  verdict: MarketingVerdict;
  summary: string;
}

export async function fetchMarketingSummary(accountId: string): Promise<MarketingSummary> {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Niet ingelogd');

  const response = await fetch(
    `/api/customers/marketing-summary?accountId=${encodeURIComponent(accountId)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || 'Marketing-samenvatting ophalen mislukt');
  }
  return response.json();
}
